<template>
  <div class="phone-number-selector-container">
    <p class="label">{{ $t('enterPhoneNumber') }}</p>
    <div class="phone-number-selector-wrapper">
      <country-selector
        :showCountryName="false"
        :selectedCountry="selectedCountry"
        @update:selectedCountry="onSelectedCountry"
      />
      <div class="divider"></div>
      <p class="country-code">+{{ (selectedCountry as NamedCountry)?.prefix }}</p>
      <input
        :value="phoneNumber"
        class="phone-number-input blank-styling"
        autofocus
        @input="(event) => onPhonenumberChanged((event.target as HTMLInputElement).value)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import CountrySelector from '@/components/CountrySelector.vue';
import { NamedCountry } from '@/models/namedcountry';

export default defineComponent({
  name: 'PhoneNumberSelector',
  components: { CountrySelector },
  props: {
    selectedCountry: {
      type: [String, Object] as PropType<string | NamedCountry>,
      required: false,
      default: '',
    },
    phoneNumber: String,
  },
  emits: ['update:selectedCountry', 'update:phoneNumber'],
  setup(_, { emit }) {
    const onPhonenumberChanged = (phonenumber: string) => {
      emit('update:phoneNumber', phonenumber);
    };

    const onSelectedCountry = (country: NamedCountry) => {
      emit('update:selectedCountry', country);
    };

    return {
      onPhonenumberChanged,
      onSelectedCountry,
    };
  },
});
</script>

<style scoped lang="scss">
@import '../flags';

.phone-number-selector-wrapper {
  display: flex;
  align-items: center;
  height: 44px;
  border: 1px solid $color-soap;
  border-radius: 8px;
  padding-left: 0.75rem;

  input,
  :deep(.dropdown-button) {
    border: 0 !important;
  }

  :deep(.dropdown-button) {
    padding: 0;
  }
}

.divider {
  border-right: 0.75px solid $color-ube;
  height: 100%;
  height: 1.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.label {
  @extend %label;
}

.country-code {
  color: $color-space-blue;
}

.phone-number-input {
  flex-grow: 1;
  padding-left: 0.25rem;
  color: $color-space-blue;
  &:focus {
    outline: none;
  }
}

.phone-number-selector-container {
  width: 100%;
  position: relative;
  display: inline-block;
}
</style>
